import { render, staticRenderFns } from "./LabQueue.vue?vue&type=template&id=71ecdec6&scoped=true"
import script from "./LabQueue.vue?vue&type=script&lang=js"
export * from "./LabQueue.vue?vue&type=script&lang=js"
import style0 from "./LabQueue.vue?vue&type=style&index=0&id=71ecdec6&prod&scoped=true&lang=css"
import style1 from "./LabQueue.vue?vue&type=style&index=1&id=71ecdec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ecdec6",
  null
  
)

export default component.exports